import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Thingies",
  "description": "",
  "published": "2006-05-31T00:00:00.000Z",
  "redirect_from": ["/blog/thingies/swizec/410"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wow, it's been five days already since an update to this section of this part of the known universe. Quite interesting what time does under posteinsteinian relativistic experiences where the mind comes to the part of time called the warp-around-my-schedule-with-lazy. It's an interesting phenomena, even Einstein could not explain it.`}</p>
    <p>{`Anyway, that aside, there are some magnificent links to be supplied within this post today; firstly the answer to the all time most important question of humanity. `}<a parentName="p" {...{
        "href": "http://www.style.org/unladenswallow/"
      }}>{`Just what IS the air speed velocity of an unladen swallow. `}</a>{`You can beat that's a `}<a parentName="p" {...{
        "href": "http://en.wikiquote.org/wiki/Holy_Grail"
      }}>{`Monty Python and the Holy Grail reference`}</a>{`. If you haven't seen that movie you are missing out on a whole lot and should hide from humanity's view until you do.`}</p>
    <p>{`There is also `}<a parentName="p" {...{
        "href": "http://www.blockfrenzy.com/"
      }}>{`this`}</a>{` little fun thing that is amazingly fun for such a simple concept as dodging a bunch of blocks with a... block.`}</p>
    <p>{`Today I've discovered `}<a parentName="p" {...{
        "href": "http://slashdot.org/"
      }}>{`this`}</a>{` `}<a parentName="p" {...{
        "href": "http://slashdot.org/"
      }}>{`thing`}</a>{` that many seem to see as a life's must and like to name `}<a parentName="p" {...{
        "href": "http://slashdot.org/"
      }}>{`Slashdot`}</a>{`. So far it's been a bit overwhelming, even the whole configuration part where you can customise a whole lot is... blam huge. So I'll have to look into that some more but it seems to be a nice source of news on the geeky side of the world.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      